module.exports = __webpack_public_path__ + "static/img/data_hongse.bfd9cb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/data_hongse.png
// module id = rmAM
// module chunks = 2